import React from 'react';
import { stats } from '../mock';

export default function StatsBar() {
  return (
    <section className="border-y border-neutral-900">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-4">
        {stats.map((s, i) => (
          <div
            key={s.label}
            className={`py-8 md:py-10 ${
              i !== 0 ? 'md:border-l border-neutral-900' : ''
            } ${i % 2 !== 0 ? 'border-l md:border-l border-neutral-900' : ''} ${
              i >= 2 ? 'border-t md:border-t-0 border-neutral-900' : ''
            }`}
          >
            <div className="font-display text-white text-[44px] md:text-[64px] leading-none">
              {s.value}
            </div>
            <div className="mt-3 mono text-[10px] md:text-[11px] tracking-[0.22em] text-neutral-500 uppercase">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
